import { Map, fromJS } from "immutable";
import {
  EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING,
  FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
  EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS,
  ANGULAR_INIT,
  UPDATE_POLICY_USER_SUCCESS,
  SET_PERSONALIZED_CONFIG_OPTION,
  UNSET_TASK_FILTERS_SUCCESS,
  SET_TASK_FILTER_LOADING,
  COMPLETE_ONBOARDING_SUCCESS,
} from "~/store/action_types";

const personalized_config_options = (state = Map(), action) => {
  switch (action.type) {
    case EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING:
      return state.merge(fromJS(action.options));
    case EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS:
    case FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS:
      return state.merge(fromJS(action.response));
    case ANGULAR_INIT:
      return state.merge(fromJS(action.response.personalized_config_options));
    case UPDATE_POLICY_USER_SUCCESS:
      return state.set(`should_update_policy`, false);
    case SET_PERSONALIZED_CONFIG_OPTION: {
      const { name, value } = action;
      return state.set(`${name}`, value);
    }
    case UNSET_TASK_FILTERS_SUCCESS: {
      const { response = [] } = action;
      return state.set(`project_task_filters`, fromJS(response));
    }
    case COMPLETE_ONBOARDING_SUCCESS: {
      return state.set(`v8_onboarding`, true);
    }
    case SET_TASK_FILTER_LOADING: {
      const { projectId, attributes } = action;
      let allProjectFilters = state.get("project_task_filters");
      let projectFilters = allProjectFilters.get(`${projectId}`) ?? Map();

      return state.set(
        `project_task_filters`,
        allProjectFilters.set(`${projectId}`, projectFilters.merge(fromJS(attributes)))
      );
    }
    default:
      return state;
  }
};

export default personalized_config_options;
